import { motion } from 'framer-motion';
import { User, MapPin, Briefcase, GraduationCap } from 'lucide-react';
import { Card } from '../ui/card';

export const AboutWindow = () => {
  return (
    <div className="space-y-6">
      {/* Profile Header */}
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="flex items-start gap-6"
      >
        <div className="relative">
          <div className="w-32 h-32 rounded-2xl bg-gradient-to-br from-primary to-accent p-1">
            <div className="w-full h-full rounded-2xl bg-background flex items-center justify-center">
              <User className="w-16 h-16 text-primary" />
            </div>
          </div>
          <div className="absolute -bottom-2 -right-2 w-8 h-8 rounded-full bg-success border-4 border-background" />
        </div>
        <div className="flex-1 space-y-2">
          <h1 className="text-4xl font-bold glow-text">Alvin Jo Regi</h1>
          <p className="text-xl text-accent">Full Stack Developer & Technical Director</p>
          <div className="flex items-center gap-4 text-sm text-muted-foreground">
            <div className="flex items-center gap-2">
              <MapPin className="w-4 h-4" />
              <span>Sharjah, UAE</span>
            </div>
            <div className="flex items-center gap-2">
              <Briefcase className="w-4 h-4" />
              <span>Freelance & Event Tech Lead</span>
            </div>
          </div>
        </div>
      </motion.div>

      {/* Bio */}
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.1 }}
      >
        <Card className="p-6 tech-border">
          <h2 className="text-xl font-bold text-primary mb-4">About Me</h2>
          <p className="text-foreground/80 leading-relaxed">
            I am a multi-disciplinary Full Stack Developer and Technical Director specializing 
            in building scalable web applications and managing complex event technology. 
            With expertise in React, Node.js, and Python, I develop full-stack solutions and 
            custom Discord bots. Beyond coding, I am a professional Photographer, Video Editor, 
            and Sound Engineer, leading technical operations for major events like TEDx and 
            school-wide festivals.
          </p>
        </Card>
      </motion.div>

      {/* Experience */}
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.2 }}
      >
        <Card className="p-6 tech-border">
          <h2 className="text-xl font-bold text-primary mb-4">Experience</h2>
          <div className="space-y-4">
            {[
              {
                title: 'Founder & CEO',
                company: 'Pinnacle Events Organizing',
                period: 'July 2024 - Present',
                description: 'Leading a professional event management and technical production firm.'
              },
              {
                title: 'Head of Event Operations',
                company: 'TEDxSISJ Youth',
                period: 'April 2025 - Present',
                description: 'Overseeing all technical aspects including sound, lighting, stage design, and visual systems.'
              },
              {
                title: 'Technical Director',
                company: 'SISJ Student Council',
                period: 'April 2023 - Present',
                description: 'Managing technical activities, audiovisual production, and digital media support.'
              },
              {
                title: 'Full Stack Freelance Developer',
                company: 'Self-Employed',
                period: 'Ongoing',
                description: 'Developing websites and apps using React, JS, TS, Node.js, and Python.'
              }
            ].map((exp, i) => (
              <div key={i} className="border-l-2 border-primary/30 pl-4 space-y-1">
                <div className="font-semibold text-foreground">{exp.title}</div>
                <div className="text-sm text-accent">{exp.company}</div>
                <div className="text-xs text-muted-foreground">{exp.period}</div>
                <div className="text-sm text-foreground/70">{exp.description}</div>
              </div>
            ))}
          </div>
        </Card>
      </motion.div>

      {/* Education */}
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.3 }}
      >
        <Card className="p-6 tech-border">
          <h2 className="text-xl font-bold text-primary mb-4 flex items-center gap-2">
            <GraduationCap className="w-5 h-5" />
            Education
          </h2>
          <div className="space-y-3">
            <div>
              <div className="font-semibold text-foreground">High School Diploma (Commerce-Sociology)</div>
              <div className="text-sm text-muted-foreground">Sharjah Indian School, Juwaiza • 2025 - 2026</div>
            </div>
          </div>
        </Card>
      </motion.div>
    </div>
  );
};

export default AboutWindow;